import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HiArrowLeft } from 'react-icons/hi2'
import { TickCircle, Folder2 } from 'iconsax-react'
import pdfIcon from '@/assets/pdf-icon.svg'

export function DescargaExitoPage() {
  const navigate = useNavigate()
  const { t } = useTranslation('simulador')
  const { state } = useLocation() as { state: { pdfFileName?: string } | null }
  const [avisoDescargas, setAvisoDescargas] = useState(false)

  if (!state?.pdfFileName) {
    navigate('/simulador', { replace: true })
    return null
  }

  const pdfFileName = state.pdfFileName

  const handleVerDescargas = () => {
    const opened = window.open('file:///Downloads', '_blank')
    if (!opened) setAvisoDescargas(true)
  }

  return (
    <div className="flex h-full min-h-[calc(100svh-6rem)] flex-col items-center justify-center p-6">
      <div className="flex w-[min(28rem,calc(100vw-2rem))] flex-col items-center gap-3 rounded-lg bg-white px-8 pt-10 pb-8 text-center shadow-[0_8px_32px_rgba(0,0,0,0.16)]">
        <div className="mb-1 flex h-12 w-12 items-center justify-center rounded-sm bg-surface-accent-soft">
          <TickCircle size={28} variant="Linear" color="var(--color-brand-primary)" />
        </div>

        <h2 className="m-0 text-[1.5rem] font-bold text-text-secondary">
          {t('descargaExitoTitle')}
        </h2>
        <p className="m-0 max-w-[22rem] text-[0.6875rem] leading-normal text-black">
          {t('descargaExitoSubtitle')}
        </p>

        <div className="mt-1 flex w-full items-center gap-3 rounded-sm bg-surface-accent-soft px-4 py-6 text-left shadow-[0_2px_4px_rgba(0,0,0,0.08)]">
          <div className="shrink-0">
            <img src={pdfIcon} alt="PDF" width={40} height={40} />
          </div>
          <div className="flex min-w-0 flex-1 flex-col items-start gap-0.5">
            <span className="font-base text-body-3 font-normal uppercase tracking-[0.06em] text-[#05141F]">
              {t('descargaExitoFileLabel')}
            </span>
            <span className="block w-full border-b-[2.5px] border-b-brand-primary pb-1 text-left text-[0.75rem] font-medium text-brand-primary">
              {pdfFileName}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="mt-2 flex cursor-pointer items-center justify-center gap-2 rounded-[0.25rem] border-0 bg-brand-primary px-5 py-2 text-[0.8125rem] font-normal text-white transition-colors duration-150 hover:bg-[#005a99]"
          onClick={() => navigate('/simulador')}
        >
          <HiArrowLeft size={18} aria-hidden />
          {t('descargaExitoVolver')}
        </button>

        <button
          type="button"
          className="flex cursor-pointer items-center gap-1.5 border-0 bg-transparent px-0 py-1 text-[0.8125rem] text-text-muted transition-opacity duration-150 hover:opacity-75"
          onClick={handleVerDescargas}
        >
          <Folder2 size={16} variant="Linear" color="currentColor" />
          {t('descargaExitoCarpeta')}
        </button>

        {avisoDescargas && (
          <p className="mt-1 text-[0.8125rem] text-text-muted">
            {t('descargaExitoAvisoText')}
          </p>
        )}

      </div>
    </div>
  )
}
